import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../app/routes";
import { AccountService } from "../../../services";
import { ChangePasswordRequest } from "../../../models";
import { showSuccessMessage } from "../../../utils";

export function useChangePassword() {
  const accountService = new AccountService();
  const [showSpinner, setShowSpinner] = useState(false);
  const navigate = useNavigate();

  const changePassword = async (request: ChangePasswordRequest) => {
    setShowSpinner(true);
    const ok = await accountService.changePassword(request);
    setShowSpinner(false);
    if (ok) {
      showSuccessMessage("Password successfully updated");
      navigate(routes.profile.index);
    }
  };

  return {
    changePassword,
    showSpinner
  };
}
